import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import { 
  Paper, Grid, Typography
} from '@material-ui/core';

const styles = {
  countContainer: {
    height: 52,
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    justifyContent: "space-around",
    textAlign: "center",
    '&:hover': {
      backgroundColor: '#f0f0f0'
    }
  },
};

const PortfolioFaultTotalize = ({ portfolioFaultTotalize, classes }) => {
  return (
    <Paper className='StationStatisticsBG'>
      <Grid container spacing={8}>
        <Grid item md sm={6} xs={6}>
          <div className={classes.countContainer}>
            <Typography className='StationStatisticsTXT'>                                        
                📊 Total Faults
            </Typography>
            {portfolioFaultTotalize.totalFaults || 0}
          </div>
        </Grid>
        <span className='VerticalDivider'></span>
        <Grid item md sm={6} xs={6}>
          <div className={classes.countContainer}>
            <Typography className='StationStatisticsTXT'>                                        
                🚨 Criticals 
            </Typography>
            <span style={{ color: '#B71C1C'}}>
              {portfolioFaultTotalize.critical || 0}
            </span>
          </div>
        </Grid>
        <span className='VerticalDivider'></span>
        <Grid item md sm={6} xs={6}>
          <div className={classes.countContainer}>
            <Typography className='StationStatisticsTXT'>                                        
                ⚠️ Warnings 
            </Typography>
            <span style={{ color: '#FB8C00'}}>
              {portfolioFaultTotalize.warning || 0}
            </span>
          </div>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default withStyles(styles)(PortfolioFaultTotalize);